import { i18n } from "services/i18nService";
import { formatDate } from "services/utility/dates";
import {
  formatMoneyWithoutAdornments,
  formatDecimal,
  extractName,
  formatTypeStringIntoLabel,
} from "services/utility/formatting";
import {
  getReportDecimalTotal,
  getReportMoneyTotal,
  formatAccountingExceptionMoney,
} from "services/utility/reports";

import { SUB_COMPONENT } from "views/Reports/reportConstants";

const type = i18n("notes.vendorCredit");

export const ReconcileVendorCredits = {
  userHasSufficientPrivilege: (p) =>
    p.sync && p.receiveInventory && p.viewCosts,
  planIncludesReport: (plus) => plus,
  customFieldObjectTypes: [],
  isJsonReport: true,
  reportAction: { id: "AddToSync", label: i18n("reports.AddToSync") },
  notes: [
    i18n("notes.YellowMeansNoMatchingInSOS", { type }),
    i18n("notes.BlueMeansNotSentToQbo", { type }),
    i18n("notes.GreenMeansNoMatchingInQbo", { type }),
    i18n("notes.RedMeansCostDoesNotMatch"),
    i18n("notes.ReconcileVendorCredits"),
  ],
  columns: [
    {
      apiName: "Date",
      jsonName: "date",
      formatFunc: formatDate,
      default: true,
    },
    {
      apiName: "Txn Type",
      jsonName: "txnType",
      formatFunc: formatTypeStringIntoLabel,
      default: true,
    },
    {
      apiName: "RefNumber",
      jsonName: "refNumber",
      label: "Ref #",
      default: true,
    },
    {
      apiName: "Vendor",
      jsonName: "vendor",
      formatFunc: extractName,
      default: true,
    },
    {
      apiName: "Item",
      jsonName: "item",
      formatFunc: extractName,
      default: true,
    },
    {
      apiName: "Qty",
      jsonName: "quantity",
      formatFunc: formatDecimal,
      footerFunc: getReportDecimalTotal,
      showTotal: true,
      default: true,
      number: true,
    },
    {
      apiName: "VendorCreditNumber",
      label: "Vendor Credit #",
      jsonName: "refNumber",
      default: true,
    },
    {
      apiName: "SOS Value",
      jsonName: "sosValue",
      formatFunc: formatMoneyWithoutAdornments,
      footerFunc: getReportMoneyTotal,
      default: true,
      number: true,
    },
    {
      apiName: "Acct Value",
      jsonName: "acctValue",
      formatFunc: formatAccountingExceptionMoney,
      footerFunc: getReportMoneyTotal,
      isExceptionColumn: true,
      default: true,
      number: true,
    },
    {
      apiName: "Diff",
      jsonName: "diff",
      formatFunc: formatAccountingExceptionMoney,
      footerFunc: getReportMoneyTotal,
      isExceptionColumn: true,
      default: true,
      number: true,
    },
  ],
  settings: [
    {
      apiName: "date1",
      macroApiName: "date1Macro",
      headerText: i18n("filter.heading.from"),
      component: "DateFilter",
      label: i18n("reports.FilterLabel.FromDate"),
      defaultValue: () => new Date(),
      datePrefix: "startOf",
      type: "filter",
    },
    {
      apiName: "date1Macro",
      defaultValue: null,
      component: SUB_COMPONENT,
      type: "filter",
    },
    {
      apiName: "date2",
      macroApiName: "date2Macro",
      component: "DateFilter",
      label: i18n("reports.FilterLabel.ToDate"),
      datePrefix: "endOf",
      defaultValue: () => new Date(),
      type: "filter",
    },
    {
      apiName: "date2Macro",
      defaultValue: null,
      component: SUB_COMPONENT,
      type: "filter",
    },
    {
      apiName: "showFromTo",
      defaultValue: false,
      label: i18n("reports.OptionLabel.ShowFromAndToDates"),
      component: "FrmCheckbox",
      type: "option",
    },
    {
      apiName: "header",
      defaultValue: "",
      label: i18n("global.Header"),
      component: "FrmTextField",
      type: "option",
    },
    {
      apiName: "footer",
      defaultValue: "",
      label: i18n("global.Footer"),
      component: "FrmTextField",
      type: "option",
    },
  ],
};
